// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"41e79e64","247":"4df4bae1","284":"07545470","440":"2cc538a7","627":"2a912e7c","867":"b99ace92","923":"3610bf5d","938":"e91f0e65"}[chunkId] + ".chunk.js";
};